import React, { useState } from 'react';

export default function Tooltip({ children, text, position = 'top' }) {
  const [show, setShow] = useState(false);

  const positionClasses = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2',
  };

  return (
    <span
      className="relative inline-flex"
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
      onFocus={() => setShow(true)}
      onBlur={() => setShow(false)}
    >
      {children}
      {show && text && (
        <span
          role="tooltip"
          className={`absolute ${positionClasses[position]} z-50 px-3 py-2 text-xs text-white bg-gray-800 border border-gray-600 rounded-lg shadow-lg max-w-xs whitespace-normal pointer-events-none`}
        >
          {text}
          <span className={`absolute w-2 h-2 bg-gray-800 border border-gray-600 rotate-45 ${
            position === 'top' ? 'top-full left-1/2 -translate-x-1/2 -mt-1 border-t-0 border-l-0' :
            position === 'bottom' ? 'bottom-full left-1/2 -translate-x-1/2 -mb-1 border-b-0 border-r-0' :
            ''
          }`} />
        </span>
      )}
    </span>
  );
}
